import { ReactElement, use } from 'react'
import { QuestionItem } from './question-item/QuestionItem'
import { ActivityContext } from '@/components/registration-check/ActivityItemProvider'
import { useActivityAnswerCollecting } from '@/components/registration-check/_hooks/UseActivityAnswerCollecting'

export const ActivityItem = (): ReactElement => {
    const { questions, canBeDeleted } = use(ActivityContext)
    useActivityAnswerCollecting()

    return (
        <>
            {questions.map((question, index) => (
                <QuestionItem key={question.id} question={question} canBeDeleted={canBeDeleted && index === 0} />
            ))}
        </>
    )
}
